function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Rocket"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 21,
  "data-height": 32,
  transform: "translate(5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.588 21.296l-4.588 10.704h3l4.027-4.027c-.81-1.347-1.814-3.522-2.44-6.677z",
  className: "iconic-rocket-fin iconic-rocket-fin-left iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.413 21.296c-.625 3.155-1.629 5.33-2.44 6.677l4.027 4.027h3l-4.587-10.704z",
  className: "iconic-rocket-fin iconic-rocket-fin-right iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 0s-5.5 5-5.5 15 4 14 4 14h3s4-4 4-14-5.5-15-5.5-15zm0 12c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5z",
  className: "iconic-rocket-body iconic-property-fill"
}));

function SvgRocketMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "rocket",
    className: "iconic iconic-rocket iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketMd);
export default __webpack_public_path__ + "static/media/rocket-md.ad8db6dc.svg";
export { ForwardRef as ReactComponent };